import Checkbox from './src/Checkbox';

export default Checkbox;
